/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getProductEligibilityV2Async } from './DataActionExtension.g';
import { IEligibilityItem } from './DataServiceEntities.g';

/**
 * GetProductEligibility Input Action
 */
export class GetProductEligibilityInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public itemIds: string[];
    public countryId: string | null;
    public stateId: string | null;
    public regionId: string | null;
    public isCheckout: boolean;
    public cartId: string;
    constructor(
        itemIds: string[],
        isCheckout: boolean,
        cartId: string,
        countryId: string | null,
        stateId: string | null,
        regionId: string | null
    ) {
        this.itemIds = itemIds;
        this.isCheckout = isCheckout;
        this.cartId = cartId;
        this.countryId = countryId;
        this.stateId = stateId;
        this.regionId = regionId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `${this.itemIds.join(';')}:${this.countryId}:${this.stateId}:${this.regionId}:${this.isCheckout}`;
    public getCacheObjectType = () => 'PRODUCTELIGIBILITY';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetProductEligibilityData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetProductEligibilityInput([], false, '', null, null, null);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetProductEligibilityInput, ctx: Msdyn365.IActionContext): Promise<IEligibilityItem[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const eligibilityData = await getProductEligibilityV2Async(
        { callerContext: ctx },
        input.itemIds,
        input.countryId || '',
        input.stateId || '',
        input.regionId || '',
        input.cartId,
        input.isCheckout
    );
    return eligibilityData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IEligibilityItem[]>>action,
    // TODO: Give your data action a unique id
    id: 'GetProductEligibility',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
